module.exports = __webpack_public_path__ + "img/breno-parts.208de060.png";